module.exports = __webpack_public_path__ + "static/media/sonyproduct4banner.5f5c62f9.jpg";